var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5191 17.89C22.8829 19.3945 21.8879 20.7202 20.621 21.7513C19.3541 22.7824 17.8539 23.4874 16.2516 23.8048C14.6492 24.1221 12.9935 24.0421 11.4293 23.5718C9.86499 23.1014 8.43974 22.2551 7.27814 21.1067C6.11653 19.9582 5.25393 18.5428 4.76575 16.9839C4.27757 15.4251 4.17868 13.7705 4.47772 12.1646C4.77675 10.5588 5.46461 9.05063 6.48116 7.77203C7.49771 6.49343 8.812 5.48332 10.3091 4.83M24.3091 14C24.3091 12.6868 24.0505 11.3864 23.5479 10.1732C23.0454 8.95991 22.3088 7.85752 21.3802 6.92893C20.4516 6.00035 19.3492 5.26375 18.136 4.7612C16.9227 4.25866 15.6223 4 14.3091 4V14H24.3091Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirections);
export default __webpack_public_path__ + "static/media/directions.a41371d5625d3f2744c5bcb617add382.svg";
export { ForwardRef as ReactComponent };